import * as AppleAuthentication from 'expo-apple-authentication';
import { Platform } from 'react-native';

export type AppleAuthResult =
  | { success: true; identityToken: string; fullName: string; email: string }
  | { success: false; cancelled?: boolean; unavailable?: boolean; error?: string };

export function isAppleSignInAvailable(): boolean {
  return Platform.OS === 'ios';
}

export async function signInWithApple(): Promise<AppleAuthResult> {
  try {
    const credential = await AppleAuthentication.signInAsync({
      requestedScopes: [
        AppleAuthentication.AppleAuthenticationScope.FULL_NAME,
        AppleAuthentication.AppleAuthenticationScope.EMAIL,
      ],
    });
    if (!credential.identityToken) {
      return { success: false, error: 'No identity token received from Apple.' };
    }
    return {
      success: true,
      identityToken: credential.identityToken,
      fullName: [credential.fullName?.givenName, credential.fullName?.familyName]
        .filter(Boolean)
        .join(' '),
      email: credential.email ?? '',
    };
  } catch (err: any) {
    if (err.code === 'ERR_REQUEST_CANCELED') {
      return { success: false, cancelled: true };
    }
    return { success: false, error: err.message };
  }
}
